module.exports = __webpack_public_path__ + "static/media/logo-login.8a2d003e.png";